var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFitnessAdvice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.284 14.0987L21.8332 12.5495L20.284 11.0003L16.4165 14.8678L7.13234 5.58366L10.9998 1.71616L9.45067 0.166992L7.9015 1.71616L6.35234 0.166992L4.034 2.48533L2.48484 0.936159L0.935671 2.48533L2.48484 4.03449L0.166504 6.35283L1.71567 7.90199L0.166504 9.45116L1.71567 11.0003L5.58317 7.13283L14.8673 16.417L10.9998 20.2845L12.549 21.8337L14.0982 20.2845L15.6473 21.8337L17.9657 19.5153L19.5148 21.0645L21.064 19.5153L19.5148 17.9662L21.8332 15.6478L20.284 14.0987Z",
    fill: "url(#paint0_linear_2002_1338)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2002_1338",
    x1: -0.338841,
    y1: 0.167005,
    x2: 23.4952,
    y2: 0.759353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0279144,
    stopColor: "#A451D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948784,
    stopColor: "#603DB1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitnessAdvice);
export default __webpack_public_path__ + "static/media/fitness-advice.4e93c1957966bb616506742067f2b281.svg";
export { ForwardRef as ReactComponent };